import BusinessLocationPage from './BusinessLocationPage';

export default BusinessLocationPage;
